import React, { FC } from 'react';

import ProductTile from '../yourtitles/ProductTile';
import { createLCCollectionProductDetailLink } from '../yourtitles/utils/product-detail-link-helpers';
import { DISPLAY_TYPE_LIST, DISPLAY_TYPE_MINIMAL, DISPLAY_TYPE_TILE } from '../../../store/displayType/types';
import ListItem from '../yourtitles/ListItem';
import { COLLECTION_NAVIGATION_V2, useFeature } from '../../../shared/utils/togglz';
interface Props {
    product: {
        fromLibXchange: boolean;
        id: string;
        isbn13: string;
    };
    displayType: typeof DISPLAY_TYPE_LIST | typeof DISPLAY_TYPE_MINIMAL | typeof DISPLAY_TYPE_TILE;
    onManageButtonClick: () => void;
}
const CollectionProductElement: FC<Props> = props => {
    const isCollectionNavigationV2Enabled = useFeature(COLLECTION_NAVIGATION_V2);
    const productIsFromLibXchange = props.product.fromLibXchange;
    const productId = productIsFromLibXchange ? props.product.id : props.product.isbn13;
    const productLinkUri = createLCCollectionProductDetailLink(
        productIsFromLibXchange,
        productId,
        isCollectionNavigationV2Enabled
    );

    const isYourTitle = false;
    const isLibxchange = false;
    const isInCollection = true;

    if (props.displayType === DISPLAY_TYPE_LIST) {
        return (
            <ListItem
                isYourTitle={isYourTitle}
                isLibxchange={isLibxchange}
                isInCollection={isInCollection}
                productLinkUri={productLinkUri}
                shopLanguage={undefined}
                {...props}
            />
        );
    } else if (props.displayType === DISPLAY_TYPE_MINIMAL || props.displayType === DISPLAY_TYPE_TILE) {
        return (
            <ProductTile
                isYourTitle={isYourTitle}
                isLibxchange={isLibxchange}
                isInCollection={isInCollection}
                productLinkUri={productLinkUri}
                shopLanguage={undefined}
                {...props}
            />
        );
    } else {
        return <div />;
    }
};

export default CollectionProductElement;
